// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_gi-2";
export var aiChatCartContainerExit = "_gi-4";
export var aiChatContainerLarge = "_gi-0";
export var aiChatContainerSmall = "_gi-1";
export var aiChatIcon = "_gi-6";
export var slideInFromRight = "_gi-3";
export var slideOutToRight = "_gi-5";